var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup166(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.389,
    height: 25.39,
    viewBox: "0 0 25.389 25.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_166",
    "data-name": "Group 166",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3463",
    "data-name": "Path 3463",
    d: "M-500.981,119.844a12.7,12.7,0,0,1,12.709-12.678,12.713,12.713,0,0,1,12.68,12.737,12.7,12.7,0,0,1-12.737,12.652A12.7,12.7,0,0,1-500.981,119.844Zm12.7-9.506a9.529,9.529,0,0,0-9.523,9.508,9.531,9.531,0,0,0,9.52,9.537,9.542,9.542,0,0,0,9.526-9.51A9.528,9.528,0,0,0-488.286,110.338Z",
    transform: "translate(500.981 -107.166)",
    fill: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3464",
    "data-name": "Path 3464",
    d: "M-334.058,271.942c.7.7,1.362,1.354,2.018,2.017a1.545,1.545,0,0,1,.429,1.654,1.579,1.579,0,0,1-2.643.618c-.623-.6-1.229-1.225-1.843-1.838-.057-.057-.118-.111-.189-.177-.074.069-.14.129-.2.191-.608.607-1.211,1.22-1.825,1.821a1.534,1.534,0,0,1-1.614.416,1.513,1.513,0,0,1-1.095-1.255,1.564,1.564,0,0,1,.5-1.436q.9-.893,1.788-1.788c.063-.063.123-.129.22-.23-.224-.212-.441-.411-.651-.619-.47-.465-.941-.929-1.4-1.4a1.563,1.563,0,0,1-.327-1.782,1.59,1.59,0,0,1,1.51-.93,1.645,1.645,0,0,1,1.116.521c.651.657,1.307,1.31,1.98,1.984.072-.067.138-.125.2-.187.614-.613,1.22-1.235,1.843-1.839a1.58,1.58,0,0,1,2.644.618,1.55,1.55,0,0,1-.43,1.655c-.593.6-1.191,1.194-1.788,1.789C-333.889,271.806-333.962,271.86-334.058,271.942Z",
    transform: "translate(348.981 -259.263)",
    fill: "#7a7a7a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup166);
export default __webpack_public_path__ + "static/media/Group 166.0f0ac1f1fe25da9fc170e2520435866a.svg";
export { ForwardRef as ReactComponent };